RivalIQ.apps.AccountStatus.module('controllers', function (controllers, App, Backbone, Marionette, $, _) {

    'use strict';

    controllers.Controller = Marionette.Controller.extend({

        start: function () {

            const me = this;
            $(App.updateCardBtn.el).on('click', me.updateCard);
            $('.x-trigger-intercom').on('click', me.showIntercom);
        },

        updateCard: function () {

            RivalIQ.execute('payment:start', {
                updateCard: true,
                plan: RivalIQ.state.account.get('plan')
            });
        },

        showIntercom: function () {
            if (window.Intercom) {
                window.Intercom('show');
            }
        }

    });

    controllers.addInitializer(function (options) {

        const controller = new controllers.Controller(options);
        controller.start();
    });

});
